/**
 * @author: subhasish.ghosh@zoom.us
 */

import React, { useState, useEffect, useRef } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import axiosInstance from "@utils/axiosInstance";
import { downloadTableExportFile } from "@utils/utils";

const Download = ({ fileName, path }) => {
  const [isError, setError] = useState(false);
  const [isDownloading, setIsDownloading] = useState(true);
  const [showMessage, setShowMessage] = useState(false);

  const hasDownloaded = useRef(false);

  useEffect(() => {
    if (fileName && !hasDownloaded.current) {
      hasDownloaded.current = true;

      const downloadFile = async () => {
        try {
          setIsDownloading(true);
    
          const url = path
            ? `/operationmonitor/api/v1/external/export?fileName=${fileName}&path=${path}`
            : `/operationmonitor/api/v1/external/export?fileName=${fileName}`;

            const response = await axiosInstance.get(url);
          

          if (response.status !== 200) {
            throw new Error("Failed to download file");
          }

          downloadTableExportFile(fileName, response);

          setIsDownloading(false);
          setShowMessage(true);
        } catch (error) {
          console.error("Error downloading file:", error);
          setError(true);
          setIsDownloading(false);
        }
      };

      downloadFile();
    }
  }, [fileName]);

  return (
    <>
      <Box sx={{ display: "flex" }}>
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            padding: "0",
            height: "100vh",
          }}
        >
          {isDownloading ? (
            <div
              className="tile-centralise-content"
              style={{
                background: "transparent",
                height: "",
                marginTop: "30vh",
              }}
            >
              <CircularProgress size="3rem" />
            </div>
          ) : isError ? (
            <Box sx={{ display: "grid", marginTop: "30vh" }}>
              <Typography color="error" variant="h6">
                Error downloading file. Please try again.
              </Typography>
            </Box>
          ) : showMessage ? (
            <Box sx={{ display: "grid", marginTop: "30vh" }}>
              <Typography color="primary" variant="h6">
                You can close this window after the file has been downloaded.
              </Typography>
            </Box>
          ) : (
            <></>
          )}
        </Box>
      </Box>
    </>
  );
};

export default Download;
